import styled from "styled-components";

export const StyledButtonWrap = styled.div``;
